<template>
  <v-card 
    hover 
    height="100%" 
    :to="{name: 'showCompany', params: { id: betrieb.slug }}"
    >
    <v-container fluid class="fill-height ma-0 pa-0">
      <v-layout column fill-height class="ma-0 pa-0">
        <v-flex class="ma-0 pa-0">
          <v-card-title
            primary-title
            class="cardbackground pt-2 pb-1 xmouseoverlink"
            style="xborder: 1px solid red;"
            width="100%"
          >
            <v-container fluid class="ma-0 pa-0">
              <v-layout row grow class="ma-0 pa-0">
                <v-flex xstyle="background-color: green;" class="ma-0 pa-0">
                    <div v-if="betrieb.image_logo" class="px-1 mb-4">
                      <v-img
                        :src="betrieb.image_logo"
                        contain
                        width="100%"
                        max-height="140"
                      ></v-img>
                    </div>
                    <h3 style="line-height: 1.6 !important" class="linehoeher title" flat>
                      {{ betrieb.vollername }}
                    </h3>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-title>
        </v-flex>
      
        <v-spacer></v-spacer>

        <v-flex shrink class="pa-0 ma-0">
          <v-divider class="grey lighten-2"></v-divider>
          <v-layout
            row
            align-center
            class="px-3 py-0"
            v-for="innung in Innungkombi"
            :key="innung.name"
            style="min-height: 70px;"
          >
            <v-flex xs9 align-self-center>
              {{ innung.name }}</v-flex>
            <v-flex v-if="innung.logo" class="px-1">
              <v-img max-height="60px" contain :src="innung.logo"></v-img>
            </v-flex>
          </v-layout>

          <v-divider></v-divider>
          <!-- <v-card-text class="pa-3">{{ betrieb.beschreibung }}</v-card-text> -->
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>

<script>
// import { mapGetters } from 'vuex'
import ListingSave from '~/components/ListingSave.vue'

export default {
  props: ['betrieb'],
  components: {
    ListingSave
  },

  data () {
    return {
      betriebcheckloading: true
    }
  },
  computed: {
    Stadtteil: function () {
      if (this.betrieb) {
        var stadtteilnullfix = this.betrieb.stadtteil || ' '
        return this.betrieb.stadt + ' ' + stadtteilnullfix
      }
    },
    Innungkombi: function () {
      const superinnung = {}
      if (this.betrieb.innung) {
        if (this.betrieb.innungen) {
          const superinnnug = [].concat(
            this.betrieb.innung,
            this.betrieb.innungen
          )
          return superinnnug
        } else {
          return this.betrieb.innung
        }
      } else if (this.betrieb.innungen) {
        const superinnung = this.betrieb.innungen
        return superinnung
      }
      return superinnung
    }
  },
  mounted: function () {},
  methods: {}
}
</script>

<style></style>
